import styled, { css } from "styled-components";
import { DIAGNOSTICS_MEDIA, DIAGNOSTICS_STEPS_COUNT } from "@/constants/diagnostics";

export const Header = styled.header<{ $step: number }>`
  position: fixed;
  z-index: 2;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  padding: 0 var(--spacing-lg);
  border-bottom: 3px solid var(--color-text-10);
  height: 78px;
  background-color: var(--color-background);
  &:after {
    content: '';
    position: absolute;
    bottom: -3px;
    left: 0;
    height: 3px;
    background-color: var(--color-primary-2);
    transition: width var(--transition-fast);
    width: ${({ $step }) => `${$step / DIAGNOSTICS_STEPS_COUNT * 100}%`};
  }
  @media ${DIAGNOSTICS_MEDIA.md} {
    height: 52px;
    justify-content: space-between;
    padding: 0 var(--spacing-md);
  }
`;

export const Logo = styled.div`
  height: 30px;
  width: 165px;
  background-size: contain;
  background-repeat: no-repeat;
  background-image: url(/images/logo-dark.svg);
  @media ${DIAGNOSTICS_MEDIA.md} {
    height: 28px;
    width: 149px;
  }
`;

export const LogoPlaceHolder = styled.div`
  width: 165px;
  @media ${DIAGNOSTICS_MEDIA.lg} {
    display: none;
  }
`;

export const Steps = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  gap: var(--spacing-md);
  @media ${DIAGNOSTICS_MEDIA.lg} {
    justify-content: flex-end;
  }
  @media ${DIAGNOSTICS_MEDIA.md} {
    display: none;
  }
`;

export const StepItem = styled.div<{ $passed: boolean }>`
  display: flex;
  align-items: center;
  gap: var(--spacing-md);
  p {
    font-size: var(--font-size-md);
    line-height: 1.5;
  }
  ${({ $passed }) => $passed ? css`
    p {
      color: var(--color-text);
      font-weight: 600;
    }
  ` : css`
    p {
      color: var(--color-text-80);
      font-weight: 500;
    }
  `}
`;

export const StyledBackButton = styled.button`
  display: none;
  @media ${DIAGNOSTICS_MEDIA.md} {
    display: flex;
    gap: var(--spacing-sm);
    background-color: transparent;
    border: none;
    cursor: pointer;
    height: 100%;
    margin-left: -16px;
    padding-left: var(--spacing-md);
    padding-right: var(--spacing-md);
    align-items: center;
    justify-content: center;
    font-size: var(--font-size-sm);
    font-weight: 600;
  }
`;